import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import LanguageSelector from "./LanguageSelector";

export default function NeokittyGame() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!localStorage.getItem("i18nextLng")) {
      i18n.changeLanguage("en").catch(() => {});
    }
  }, [i18n]);

  const lang = i18n.language || "en";

  const backToHome = lang === "en" ? "/" : `/${lang}`;

  const getTitle = () => {
    switch (lang) {
      case "es":
        return "EN CONSTRUCCIÓN";
      case "ru":
        return "В РАЗРАБОТКЕ";
      case "zh":
        return "正在建设中";
      default:
        return "UNDER CONSTRUCTION";
    }
  };

  const getSubtitle = () => {
    switch (lang) {
      case "es":
        return "Estamos construyendo algo grande para NeoKitty.";
      case "ru":
        return "Мы создаём нечто большое для NeoKitty.";
      case "zh":
        return "我们正在为 NeoKitty 打造重要内容。";
      default:
        return "We are building something big for NeoKitty.";
    }
  };

  return (
    <>
      {/* SEO */}
      <Helmet>
        <html lang={lang} />
        <title>NeoKitty Game | Under Construction</title>
        <meta
          name="description"
          content="NeoKitty Game is under construction. Stay tuned for upcoming gaming features."
        />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-[#071029] via-[#071a3a] to-[#04233f] text-white antialiased">
        <LanguageSelector />

        {/* CONTENT */}
        <main className="max-w-4xl mx-auto px-6 py-24 flex flex-col items-center text-center">
          <img
            src="/assets/neokitty-under-construction.png"
            alt="NeoKitty under construction"
            className="w-72 md:w-96 mb-10 drop-shadow-[0_0_20px_#00E6FF70]"
          />

          <h1 className="text-4xl md:text-5xl font-extrabold drop-shadow-[0_0_16px_#00E6FF70]">
            {getTitle()}
          </h1>

          <p className="mt-4 text-slate-300 max-w-xl">
            {getSubtitle()}
          </p>

          {/* BACK TO HOME */}
          <div className="mt-12">
            <a
              href={backToHome}
              className="inline-flex items-center gap-2 px-6 py-3 border border-white/20 rounded-xl font-semibold hover:bg-white/10 transition shadow-[0_0_12px_#00E6FF40]"
            >
              ← {t("common.back_home")}
            </a>
          </div>
        </main>
      </div>
    </>
  );
}
